<template>
  <div class="login-wrapper">
    <div class="main">
      <div class="banner" :class="{ kang: channelId == 2 }"></div>
      <div class="content">
        <div class="content-head">
          <!-- <div class="label">体验课</div> -->
          <div class="text">{{ titleText }}</div>
          <div class="left">
            <div class="left-l">
              <div class="l-icon">￥</div>
              <div class="l-text">0</div>
            </div>
            <div class="left-r">
              <div class="r-text">￥99.9</div>
            </div>
          </div>
        </div>
        <div class="content-price">
          4节思维启蒙体验课+4节少儿数独L1体验课 =8节双课体验
        </div>
      </div>
      <div class="main-img-wrapper">
        <img :src="mainImg1" class="main-img" />
      </div>
      <!-- 作用 -->
      <div class="effect-wrapper">
        <div class="main-text">
          <div class="icon icon-l"></div>
          <div class="text">
            <div class="up">让孩子爱学习、会思考</div>
            <!-- <div class="down">让孩子爱学习、会思考</div> -->
          </div>
          <div class="icon icon-r"></div>
        </div>
        <div class="effect-main">
          <div class="effect-swiper-wrapper">
            <swiper class="effect-swiper" :options="swiperOption">
              <swiper-slide
                class="effect-slide"
                v-for="(item, index) in effectlist"
                :key="index"
              >
                <div class="effect-item">
                  <img :src="item.url" class="effect-img" />
                  <div class="effect-text">{{ item.text }}</div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>
      <!-- 模式 -->
      <div class="mode-wrapper">
        <div class="main-text">
          <div class="icon icon-l"></div>
          <div class="text">
            <div class="up">全新教学模式</div>
            <div class="down">保证学习效果</div>
          </div>
          <div class="icon icon-r"></div>
        </div>
        <div class="mode-list">
          <div class="mode-item" v-for="(item, index) in duList" :key="index">
            <img :src="item.img" class="mode-img" />
            <!-- <div class="mode-text">{{ item.text }}</div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="btn" @click="exchangeClick">立即兑换</div>
    </div>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper"
import "swiper/css/swiper.css"
import wx from "weixin-js-sdk"
import { getAppId, getSdk } from "../../request/api/study"
import { ERROR_OK } from "../../request/http"
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  data () {
    return {
      effectlist: [
        {
          text: "激发学习兴趣",
          url: require("./effect-1.jpg")
        },
        {
          text: "实现自主学习",
          url: require("./effect-2.jpg")
        },
        {
          text: "让未来学习更轻松",
          url: require("./effect-3.jpg")
        }
      ],
      swiperOption: {
        slidesPerView: 2,
        spaceBetween: 6,
        freeMode: true
      },
      swiperOptionTop: {
        loop: true,
        loopedSlides: 3, // looped slides should be the same
        spaceBetween: 10
      },
      swiperOptionThumbs: {
        loop: true,
        loopedSlides: 3, // looped slides should be the same
        spaceBetween: 14,
        centeredSlides: false,
        slidesPerView: "auto",
        touchRatio: 0.2,
        slideToClickedSlide: true
      },
      duList: [
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/DzkzB8MQp5siJaGdi2ecJKewHS23R5GQ.png"
        },
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/6fQNa6EaSFNtWDNTA7a2AninBnDXdjYe.png"
        },
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/6YRFeGiFYhxje7kNfneH3ww24CKda2Hd.png"
        },
        {
          img:
            "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2012/36HNbdsezW5DcWSGHp2NFYJyXySRcafD.png"
        }
      ],
    }
  },
  created () {
    this.openid = this.$route.query.openid
    this.channelId = this.$route.query.channelId || 1
    this.distributorId = this.$route.query.distributorId || ""
    if (
      navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
      "micromessenger"
    ) {
      this.getAppIdInfo()
    }
  },
  computed: {
    mainImg1 () {
      return require("./main3.png")
    },
    mainImg2 () {
      if (this.channelId == 2) {
        return require("./main2-2.png")
      }
      return require("./main2.png")
    },
    titleText () {
      let text = "思维启蒙+数独双课体验"
      // if (this.channelId == 2) {
      //   text = "泰康专属双周趣味思维体验课"
      // } else {
      //   text = "趣味思维体验课"
      // }
      return text
    },
    price () {
      let price = ""
      if (this.channelId == 2) {
        price = 168
      } else {
        price = 39.9
      }
      return price
    }
  },
  methods: {
    getWxCode () {
      var distributorId = this.$route.query.distributorId || ''
      console.log(distributorId, 'ffggg')
      let appid = "wx3dcc8b8f8d8bf78b" //为测试号id
      let local = `http://jimuaike.com/wap/#/order?channelId=1&distributorId=${distributorId}`
      console.log(local, '的饭滚滚滚')
      let url = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_base&state=1#wechat_redirect`
      window.location.replace(url)
    },
    exchangeClick () {
      this.getWxCode()
      // this.$router.push({
      //   name: "Order",
      //   query: {
      //     openid: this.openid,
      //     channelId: this.channelId,
      //     distributorId: this.distributorId
      //   }
      // })
    },
    async getAppIdInfo () {
      let { code, data } = await getAppId({})
      if (code === ERROR_OK) {
        console.log(data)
        const appId = data.appId
        let timestamp = Math.floor(+new Date() / 1000)
        let nonceStr = timestamp + "1"
        let url = window.location.href.split("#")[0]
        let { code: sdkCode, data: sdkData } = await getSdk({
          timestamp,
          nonceStr,
          url,
          appId
        })
        if (sdkCode === ERROR_OK) {
          const signature = sdkData.signature
          await wx.config({
            debug: false,
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: ["updateAppMessageShareData", "updateTimelineShareData"]
          })
          wx.error(res => {
            console.log(res)
          })
          wx.ready(() => {
            this.updateAppMessageShareData()
            this.updateTimelineShareData()
          })
        }
      }
    },
    updateAppMessageShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      wx.updateAppMessageShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    },
    updateTimelineShareData () {
      let title =
        "你的朋友送你一周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      if (this.channelId == 2) {
        title = "你的朋友送你双周趣味思维AI课，课程太有趣了，我家宝贝正在上！"
      }
      let desc = "做好思维启蒙，让孩子爱学习，会思考"
      let imgUrl =
        "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/H6r2fkdwK4hHCjA5Ts6yTYPCEcfwcG5R.png"
      if (this.channelId == 2) {
        imgUrl =
          "https://jimu-edu.oss-cn-beijing.aliyuncs.com/image/2009/pd6yjBzne4BNSK8BW8ZDFrGCa4HTXzZz.png"
      }
      wx.updateTimelineShareData({
        title,
        desc,
        link: window.location.href,
        imgUrl,
        success () {
          console.log("分享成功")
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.login-wrapper {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 0px;
  left: 0;
  bottom: 0;
  right: 0;
  background: #f4f4f4;
  .main {
    flex: 1;
    overflow-y: auto;
    .main-text {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 60px;
      .icon {
        width: 38px;
        height: 44px;
        &.icon-l {
          margin-right: 25px;
          background: url(./icon-l.png) no-repeat;
          background-size: cover;
        }
        &.icon-r {
          margin-left: 25px;
          background: url(./icon-r.png) no-repeat;
          background-size: cover;
        }
      }
      .text {
        text-align: center;
        font-size: 40px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #222222;
        line-height: 56px;
      }
    }
    .banner {
      width: 100%;
      height: 420px;
      background: url("./banner.png") no-repeat;
      background-size: cover;
      // &.kang {
      //   background: url("./banner@2x2.png") no-repeat;
      //   background-size: cover;
      // }
    }
    .content {
      padding: 30px;
      background: #fff;
      .content-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .label {
          padding: 5px 10px;
          background: linear-gradient(90deg, #fe8124 0%, #ff4c11 100%);
          border-radius: 17px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
        .text {
          font-size: 34px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #222222;
          line-height: 48px;
        }
        .left {
          display: flex;
          align-items: center;
          .left-l {
            display: flex;
            align-items: baseline;
            .l-icon {
              font-size: 28px;
              font-family: SFProDisplay-Regular, SFProDisplay;
              font-weight: 400;
              color: #ff5330;
              line-height: 34px;
            }
            .l-text {
              font-size: 40px;
              font-family: SFProDisplay-Medium, SFProDisplay;
              font-weight: 500;
              color: #ff5330;
              line-height: 48px;
            }
          }
          .left-r {
            display: flex;
            margin-left: 24px;
            .r-text {
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 40px;
            }
          }
        }
      }
      .content-price {
        width: 395px;
        text-align: left;
        margin-top: 16px;
        font-size: 21px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 29px;
      }
    }
    .main-img-wrapper {
      padding: 40px 30px 0;
      margin-top: 20px;
      background-color: #fff;
      .main-img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
    .effect-wrapper {
      padding-top: 60px;
      background: #fff;
      .effect-main {
        padding: 40px 0 60px 32px;
        .effect-slide {
          width: 320px !important;
          .effect-item {
            .effect-img {
              display: block;
              width: 100%;
              height: 282px;
              border-top-left-radius: 16px;
              border-top-right-radius: 16px;
            }
            .effect-text {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 93px;
              background: #fff;
              font-size: 32px;
              border-bottom-right-radius: 16px;
              border-bottom-left-radius: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #222222;
            }
          }
        }
      }
    }
    .mode-wrapper {
      background: #fff;
      .mode-title {
        padding: 20px 32px 0;
        text-align: justify;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #8f8f8f;
        line-height: 39px;
      }
      .mode-list {
        padding-bottom: 60px;
        margin: 30px 32px 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .mode-item {
          &:nth-child(n + 3) {
            margin-top: 26px;
          }
          .mode-img {
            display: block;
            width: 329px;
            height: 214px;
          }
          .mode-text {
            text-align: center;
            margin-top: 30px;
            font-size: 32px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #222222;
            line-height: 45px;
          }
        }
      }
    }
  }
  .footer {
    height: 120px;
    padding: 15px 40px;
    background: #fff;
    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 90px;
      border-radius: 10px;
      background: #0293de;
      font-size: 34px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
    }
  }
}
</style>
